<template>
  <el-dialog
    v-if="ExcelModal"
    title="Excel ile Banka Ekstresi Yükle"
    :visible.sync="ExcelModal"
    append-to-body>
    <a @click="SayfaYukle" class="ModalKapat"><i class="el-icon-close"></i></a>
    <div class="icerik">
      <div class="container-fluid mt-5">
        <el-row :gutter="24">
          <el-col :span="20" :offset="2">
            <el-steps :active="AktifStep" finish-status="success">
              <el-step title="Dosya Seçimi" description="Excel Dosyanızı Seçiniz"></el-step>
              <el-step title="Kontrol & Onay" description="İçe Aktarım için kontrol edin"></el-step>
              <el-step title="Veri Geçişi" description="Aktarım sonucu"></el-step>
            </el-steps>
          </el-col>
        </el-row>
      </div>

      <div v-if="AktifStep===1" class="mt-5">
        <el-row :gutter="24">
          <el-col :span="20" :offset="2">
            <div class="alert alert-info">Şimdi bir tık ile bütün verilerinizi aidatım'a aktarın.<br>
              Hazırladığınız şablon Excel dosyasını ön izlemeli olarak göstereceğiz.
            </div>
            <el-row :gutter="24">
              <el-col :span="12">
                <label for="file" type="button" class="el-button el-button--success btn-block">
                  <i class="feather-upload"></i>
                  Excel
                  Dosyası
                  Yükle </label>
                <input type="file" class="el-upload__input" id="file" accept=".xlsx,.xls"
                       @change="ExcelSecimi">
              </el-col>

              <el-col :span="12">
                <a href="https://drive.google.com/uc?authuser=0&id=10IZ1MBiG8HoFXVQD6N0mgECjIrpfb9R9&export=download"
                   target="_blank" class="el-button el-button--primary btn-block">Örnek Excel Dosyası İndir
                  <i class="feather-download"></i></a>
              </el-col>
            </el-row>

          </el-col>
        </el-row>
      </div>

      <div v-if="AktifStep===2" class="mt-5">
        <el-row :gutter="20" class="mb-5">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Excel dosyanızı aşağıdaki tabloda derledik<br>
              Kontrol ederek içe aktarabilirsiniz.
            </div>
            <el-row :gutter="20">
              <el-col :span="16">
                <el-button type="primary" @click="AktifStep=1" icon="el-icon-caret-left">Dosya Seçimine
                  Dön
                </el-button>
              </el-col>
              <el-col :span="8">
                <el-button type="success" @click="Onayla" class="float-right" icon="el-icon-check">
                  Onayla ve
                  içe Aktar
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <table class="table table-hover table-sm">
          <thead>

          <tr>
            <th>Tür</th>
            <th>Referans No</th>
            <th>İşlem Tarihi</th>
            <th>Açıklama</th>
            <th>Tutar</th>
          </tr>

          </thead>
          <tbody>
          <tr v-for="(r, key) in data" v-if="key>1" :key="key">
            <td v-for="c in cols" :key="c.key"> {{ r[c.key] }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-if="AktifStep===3" class="mt-5">
        <el-row :gutter="20" class="mb-5">
          <el-col :span="12" :offset="6">
            <div class="alert alert-info">Verilerinizin geçişi tamamlandı<br>
              Banka ekstreniz artık aidatım'da.
            </div>
            <el-row>
              <el-col :span="24">
                <el-button type="success" @click="SayfaYukle" class="float-right" icon="feather-airplay">
                  Banka Hesapları
                </el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>

    </div>
  </el-dialog>
</template>

<script>
import XLSX from 'xlsx';

const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
  name: XLSX.utils.encode_col(i),
  key: i
}));
export default {
  props: ['ExcelModal'],
  data() {
    return {
      AktifStep: 1,
    }
  },
  methods: {
    SayfaYukle() {
      this.AktifStep = 1;
      this.$emit('ExcelModal', false)
    },
    Onayla() {
      this.AktifStep = 3;
      this.$store.dispatch("Post", {...this.data, path: 'entegrasyon/ekstre/'})
        .then(response => {
          if (response.Durum == "OK") {
            this.$message.success(response.Mesaj);
            this.SayfaYukle();
            //this.$router.push('/yonetim/bina/' + this.Bina_id)
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        })

    },
    ExcelSecimi(evt) {
      const files = evt.target.files;
      if (files && files[0]) this._file(files[0]);
    },
    _file(file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const bstr = e.target.result;
        //const wb = XLSX.read(bstr, {type: 'binary'});
        const wb = XLSX.read(bstr, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws, {raw: false, header: 1, dateNF: "DD-MM-YYYY HH:mm:ss"});
        //const data = XLSX.utils.sheet_to_json(ws, {header: 1});
        this.data = data;
        this.cols = make_cols(ws['!ref']);
        this.AktifStep = 2;
      };
      reader.readAsBinaryString(file);
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Vezne/ExcelBankaEkstre.vue